// const myStory = [
//   {
//     id: "story-part-1",
//     icon: "next",
//     to: "#story-part-2",
//     content:
//       "My unwavering passion for computers and how they work didn’t kick-start until the end of my first year in uni. At that time, I was naive and had a vague understanding of anything that involves writing computer program.",
//   },s
//   {
//     id: "story-part-2",
//     icon: "next",
//     to: "#story-part-3",
//     content:
//       "I decided to free myself from the ignorance that had plagued me for a very long time. So, during my preparation for sophomore I starting my learning journey. ",
//   },
//   {
//     id: "story-part-3",
//     icon: "next",
//     to: "#story-part-4",
//     content:
//       "More than 3 years have passed now and over the years I have picked up various web technologies, framework and design practice and patterns as a result of which I amazed a vast knowledge of programming. I have build solutions for small businesses, start-ups, and companys.",
//   },
//   {
//     id: "story-part-4",
//     icon: "end",
//     to: "#work-experience",
//     content:
//       "Of course, above all, my greatest feat was setting foot into the world of problem solving which lead me to the understanding that it isn’t enough to learn how to build something but that more importantly building something that solves a problem.",
//   },
// ];

// export default myStory;
const myStory = [
  {
    id: "story-part-1",
    icon: "next",
    to: "#story-part-2",
    content:
      "My passion for computers and how they work didn’t begin until the end of my first year at university. At that time, I was naive and had only a vague understanding of programming.",
  },
  {
    id: "story-part-2",
    icon: "next",
    to: "#story-part-3",
    content:
      "I decided to break free from the ignorance I had carried for a long time. During my preparation for sophomore year, I started my learning journey.",
  },
  {
    id: "story-part-3",
    icon: "next",
    to: "#story-part-4",
    content:
      "Over the past four years, I’ve picked up various web technologies, frameworks, design practices, and patterns, amassing a vast knowledge of programming. I have built solutions for small businesses, start-ups, and companies.",
  },
  {
    id: "story-part-4",
    icon: "end",
    to: "#work-experience",
    content:
      "Above all, my greatest accomplishment was entering the world of problem-solving, which led me to realize that it’s not enough to simply build something; it’s far more important to build something that solves a real problem.",
  },
];

export default myStory;
